// extracted by mini-css-extract-plugin
module.exports = {"about-header":"index__about-header__w-Irw","informationTitle":"index__informationTitle__19rw9"};